<template>
   <div class="add_address" v-loading.fullscreen.lock="loading">
       <breadcrumb :breadcrumb="crumbList"></breadcrumb>
       <div class="add_address_box">
           <div class="add_address_box_title">{{editId ? '修改' : '新增'}}{{form.type == 1 ? '发货地址' : '收货地址'}}</div>
           <el-form class="add_address_box_form" label-width="100px">
               <el-form-item label="姓名/名称：" v-if="form.type == 1">
                    <el-input v-model="form.contacts_name" placeholder="请输入联系人的名称或公司名称"></el-input>
                </el-form-item>
                 <el-form-item label="联系方式：" v-if="form.type == 1">
                    <el-input v-model="form.contacts_phone" placeholder="请输入联系人的手机号"></el-input>
                </el-form-item>
                 <el-form-item label="公司名称：">
                    <el-input v-model="form.owner_name" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                 <el-form-item label="所在地区：">
                    <!-- <el-input v-model="form.name" placeholder="请输入联系人的所在地区"></el-input> -->
                    <mapSelectAddress :placeholder="'请选择城市'" ref="addAddressMap" @selectMap="selectEndMap"></mapSelectAddress>
                </el-form-item>
                 <el-form-item label="详细地址：" class="add_address_box_from_item">
                    <el-input type="textarea" v-model="form.detalied_address" resize="none" rows="4" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                 <el-form-item label="">
                    <el-checkbox v-model="form.checked">设置为默认地址</el-checkbox>
                </el-form-item>
                <el-form-item class="add_address_box_from_item">
                    <el-button class="" type="primary" @click="submit()">保存</el-button>
                </el-form-item>

           </el-form>
       </div>
   </div>
</template>

<script>
import mapSelectAddress from '@/components/mapSelectAddress'
import breadcrumb from '@/components/breadcrumb'
export default {
   data (){
       return {
           crumbList:[
               {name:'个人中心',path:'/message'},
               {name:'地址簿',path:'/address'},
               {name:'新增地址',path:'/add_address'}
           ],
           form:{
               detalied_address:'',
               longitude:'',
               latitude:'',
               owner_name:'',
               province:'',
               city:'',
               district:'',
               is_default:0,
               type:1,
               contacts_name:'',
               contacts_phone:''
           },
           endAddressData:{},
           editId:'',
           loading:false
       }
   },
   components: {
       breadcrumb,
       mapSelectAddress
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       submit(){
           this.form.is_default = this.form.checked ? 1 : 0;
           if(this.form.id){
               this.$put('Address/' + this.form.id,this.form)
                    .then(data => {
                        this.$message.success('修改成功');
                        this.$router.push({name:'address',params:{type:this.form.type}});
                    } , error => {
                        this.$message.error(error);
                    });
           }else{
               this.$post('Address',this.form)
                    .then(data => {
                        this.$message.success('保存成功');
                        this.$router.push({name:'address',params:{type:this.form.type}});
                    } , error => {
                        this.$message.error(error);
                    });
           }
           
           
       },
        // 收件人的地址选择
       selectEndMap(address){
           this.form.province = address.province;
           this.form.city = address.city;
           this.form.district = address.district;
           this.form.longitude = address.lng;
           this.form.latitude = address.lat;
           this.form.detalied_address = address.address;
           this.endAddressData = address;
       },
       getDetails(id){
           this.loading = true;
           this.$get('Address/' + id , {})
            .then(data => {
                this.form = data;
                if(this.form.is_default){
                    this.form.checked = true;
                }
                this.$refs.addAddressMap.initAddress(this.form);
                this.loading = false;
            }, error => {
                this.$$message.error(error);
                this.loading = false;
            });
       }
   },
   created() {
       this.editId = this.$route.query.id;
       this.form.type = this.$route.query.type;
       let str = '';
       if(this.editId){
           this.getDetails(this.editId);
           str = '修改'
       }else{
           str = '新增'
       }
       this.crumbList[2].name = str +  (this.form.type == 1 ? '发货地址' : '收货地址')
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.add_address{
    padding:0 20px ;
    &_box{
        &_title{
            font-size: 20px;
            font-weight: 500;
            color:#333;
            padding: 20px 0;
        }
        &_form{
            width:400px;
            /deep/ .el-form-item{
                margin-bottom:18px;
            }
            /deep/ .el-input__inner{
                border-radius: 0px;
                height: 36px;
                line-height: 36px;
            }
            /deep/ .el-form-item__label{
                color:#666;
                font-size: 16px;
                font-weight: 400;
            }
            /deep/ .el-checkbox__label{
                color:#999999;
                font-size: 18px;
                font-weight: 400;
            }
            /deep/ .el-checkbox__inner{
                position: relative;
                top: -2px;
            }
            /deep/ .add_address_box_from_item.el-form-item{
                margin-bottom:8px;
                .el-button{
                    width:100%;
                    font-size: 18px;
                    font-weight: 400;
                    background: #1F9EFF;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/address/addAddress.vue